// extracted by mini-css-extract-plugin
export default {"map_wrap":"Map_map_wrap__KQ8Cw","map":"Map_map__tZxNi","tooltip":"Map_tooltip__rUL9T","col1":"Map_col1__EWrYK","col2":"Map_col2__vvvFH"};